/* eslint-disable */
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json
import api from '../../api'
//获取产品信息

const state = { 
} 
const mutations = { 
} 
const getters = { 
}

const actions = {
  // 展会id获取商机
  // status 
  // - 10：All = 全部
  // - 1：UnAudited = 审核失败
  // 0：Submited = 已提交
  // 1： Audited = 已审核
  // /api/release/GetByExhibition?status=-10
  getReleaseByExhibition({ rootState }, opt) { // status  
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/release/GetByExhibition`, opt, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editReleaseStatus({ rootState }, opt) { // 修改审核状态 
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/release/SetAuditStatus`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editReleaseHandle({ rootState }, id) { // 修改审核状态 
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/Release/Handle?releaseId=${id}`, {}, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editReleaseShow({ rootState }, opt) { // 修改审核状态  
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/Release/SetIsShow?releaseId=${opt.id}&isShow=${opt.bool}`, {}, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 公司id获取商机
  getRelease({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Release/GetAndChildrenByCompId?userId=${rootState.user.id}`, opt, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  delRelease({ rootState }, id) { // 删除成功案例
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/release?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editRelease({ rootState }, opt) { // 修改成功案例
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/release`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  addRelease({ rootState }, opt) { // 添加成功案例
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/release`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  }, 

  getReleaseComment({ rootState }, opt) { // 商机留言
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/releaseComment/GetByReleaseId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  delReleaseComment({ rootState }, id) { // 删除商机留言
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/releaseComment?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  sendReleaseComment({ rootState }, opt) { // 回复商机留言
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/releaseComment`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}